import { render, staticRenderFns } from "./ApiPage.vue?vue&type=template&id=7ffe4b85&"
import script from "./ApiPage.vue?vue&type=script&lang=js&"
export * from "./ApiPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports